import React, {Component} from 'react';
import {LABEL} from 'js/constants';
import styles from 'css/components/header.css';

/**
 * Header
 */
export default class Header extends Component {
  /**
   * render jsx
   * @return {jsx}
   */
  render() {
    return (
      <header className={styles.header}>
        <div className={styles.frame}>
          <a className={styles.logo} onClick={() => {
            location.href = 'https://www.bil.jp/';
          }} />
          <div className={styles.text}>
            BILCOM 市場創造PR力診断{LABEL.appType}
          </div>
        </div>
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/header/index.js